module.exports = __webpack_public_path__ + "static/media/superadmin.fdf8bbc7.jpg";